import Notes from '@mui/icons-material/Notes'
import React from 'react'

export default function RenderNoteOverReport({ text }) {
  if (text) {
    return (
      <div
        className="hide-on-print-only"
        style={{
          border: '1px solid #cecece',
          borderRadius: '4px',
          background: 'rgba(206,206,206,0.5)',
        }}
      >
        <Notes />
        <b>Private Note:</b> <span style={{ color: '#7200a4' }}>{text}</span>
      </div>
    )
  }
}
